import * as React from "react";

function SvgAddUser(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.906 0h3.047v3.047H32v3.047h-3.047v3.047h-3.047V6.094h-3.047V3.047h3.047V0zM.006 27.987s-.005.058.013.15c-.01.254-.014.524-.014.81a154.96 154.96 0 000 2.713l.001.881s2.046 4.025 13.894 4.025c11.849 0 13.53-3.81 13.53-3.81v-.445a3577.63 3577.63 0 01.002-3.23v.012l.001-.002V29.05v.03c-.002-.017-.002-.057-.004-.133 0-.26-.009-.511-.026-.756.033-.124.026-.205.026-.205-.299-5.725-5.397-8.093-5.397-8.093-1.19-.562-3.324-1.649-4.771-2.392 1.544-1.59 2.55-4.19 2.55-7.128v-.069c.155-1.798.028-3.53.028-3.53-.354-5.175-5.53-5.257-6.073-5.251h-.049-.041c-.492-.006-5.725.046-6.081 5.25 0 0-.127 1.737.028 3.538v.062c0 2.938 1.007 5.539 2.551 7.128-1.448.744-3.581 1.83-4.772 2.392 0 0-5.097 2.368-5.396 8.093z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgAddUser;
